import React from "react";
import sv from "../locales/sv.json";
import en from "../locales/en.json";

const TRANSLATIONS = { sv, en };

const LangContext = React.createContext({ lang: "sv", setLang: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLang] = React.useState("sv");
  return (
    <LangContext.Provider value={{ lang, setLang }}>
      {children}
    </LangContext.Provider>
  );
}

export function useTranslation() {
  const { lang, setLang } = React.useContext(LangContext);
  const translations = TRANSLATIONS[lang] || TRANSLATIONS.sv;

  function t(key) {
    const keys = key.split(".");
    let val = translations;
    for (const k of keys) {
      val = Array.isArray(val) ? val[parseInt(k)] : val?.[k];
      if (val === undefined) return key;
    }
    return typeof val === "string" ? val : key;
  }

  function resolve(field) {
    if (!field && field !== 0) return "";
    if (typeof field === "string") return field;
    return field[lang] ?? field.sv ?? "";
  }

  return { t, lang, setLang, translations, resolve };
}
